import React from 'react';
import '../App.css';

function HomeBanner (){
    return (
     <div className="home_banner__section">
         <h2 className="home_banner__header">BadAss TadPoles,  GoodAss Deeds</h2>
     </div>
    )
}
export default HomeBanner;